module.exports = __webpack_public_path__ + "media/images/services/01-435133602c3d315089ce14e24a29286a.jpg";